import React, { useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Login.css';
import gox from '../../assets/gox.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../../action/user';
function Login() {
 
  // const [action, setAction] = useState('submit');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [buttonIsActive, setButtonIsActive] = useState(true)




  const signinData = useSelector((state) => state?.signin)
  console.log(signinData)



  const [passwordVisible, setPasswordVisible] = useState(false);


  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };


  

  // const signin = useSelector((state) => state?.signin)
  // console.log(signin)

    const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(signin(email, password));
    console.log('homepage')
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

    // dispatch(signin(email, password))
    useEffect(() => {
      if (email === "" || password === "") {
        setButtonIsActive(true)
      } else {
        setButtonIsActive(false)
      }
    }, [email, password])



    useEffect(() => {
      const data = sessionStorage.getItem("userInfo");
      if (data) {
        navigate("/Employee");
        console.log(data)
      }
    }, [ navigate, signinData, handleSubmit]);



  return (
    <>
      <div className='banner d-flex'>
        <div className="left px-5 py-5">
          <div className='pb-5'> <h6>GOX Register</h6></div>
          <div>

            <div className='pt-5 pb-5'>
              <h1> Where finance <br /> meets management.</h1>
              <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum
                et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit
                interdum et feugiat odio.
              </p>
            </div>

            <div className='dynamic p-3'>
              <p>
                In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of employee well-being. We see our mission as not just managing resources, but as stewards of an environment
                where each person's unique skills and perspectives are valued.
              </p>
              <div className='d-flex mt-5 '>
                <div className='mx-2'><img src={gox} alt="logo" /></div>
                <div>
                  <h6>Gox register</h6>
                  <p>Our mission</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="container forms mt-5 "  >
          <div className="">
            {/* Left Column with H1 and P Tag */}
            <div className=" welcome col-md-6">
              <h1>Welcome back</h1>
              <p>Enter details to login</p>
            </div>
            {/* Right Column with Form */}
            <div className="col-md-6">
              <form  onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input type="email" className="form-control" id="email" placeholder="Email" onChange={handleEmailChange} value={email}
             />
                </div>

                <div className="mb-3 input-container">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-with-icon">
                  <input
                      type={passwordVisible ? 'text' : 'password'}
                      className="form-control"
                      id="password"
                      placeholder="Password"
                      onChange={handlePasswordChange}
                      value={password}
                    />
                   <i
                      className={`fa ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                      id="togglePassword"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}>
                  </i>
                  </div>

                  <div className="remember">
                    <div className="mb-3 form-check">
                      <input type="checkbox" className="form-check-input mt-4" id="acceptTerms" />
                      <label className="form-check-label mt-3" htmlFor="acceptTerms">Remember me</label>
                    </div>

                    {/* Add the "Forgot Password?" link */}
                    <div className="mb-3">
                      <p>
                        <Link to="/forgotten-password">Forgot password?</Link>
                      </p>
                    </div>
                  </div>
                </div>

                  
                  <button type="submit" className="btn btn1  w-100" isActive={buttonIsActive} >Continue</button>
                
              </form>
              <div className="mt-3">
                <p onClick={() => navigate('/create-account') }>Don't have an account? <span className='icon-link icon-link-hover'>Sign up</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login;

